import React from 'react';
import { Outlet } from 'react-router-dom';

import TestEnvBannerComponent from '../_components/test-environment-banner';
import { useThemeContext } from '../app/theme-provider';

import Footer from './footer';
import Header from './header';
import styles from './layout.module.scss';

export function AppLayout() {
  const { theme } = useThemeContext();
  return (
    <div className={styles.app} data-bs-theme={theme}>
      <TestEnvBannerComponent />
      <Header />
      <div className={`${styles.main} flex-fill pt-3 px-3 pb-4`}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
